import { render, staticRenderFns } from "./HowToRepayTab.vue?vue&type=template&id=70fc6a8e&scoped=true"
import script from "./HowToRepayTab.vue?vue&type=script&lang=js"
export * from "./HowToRepayTab.vue?vue&type=script&lang=js"
import style0 from "./HowToRepayTab.vue?vue&type=style&index=0&id=70fc6a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc6a8e",
  null
  
)

export default component.exports